import { render, staticRenderFns } from "./CbxIllnessType.vue?vue&type=template&id=f81d7944&"
import script from "./CbxIllnessType.vue?vue&type=script&lang=ts&"
export * from "./CbxIllnessType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports